import { PROMOTION_MANAGEMENT_INIT_LOADING, PROMOTION_MANAGEMENT_INIT_SUCCESS, PROMOTION_MANAGEMENT_INIT_FAIL, CAMPAIGN_INIT_LOADING, CAMPAIGN_INIT_SUCCESS, CAMPAIGN_INIT_FAIL, CAMPAIGN_SIDEMENU, PROMOTION_INIT_LOADING, PROMOTION_INIT_SUCCESS, PROMOTION_INIT_FAIL, PROMOTION_SIDEMENU, PROMOTION_PROMOFACT_TABMENU, PROMOTION_PROMOFACT, PROMOTION_FACTORLIST } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'
import http, { expandURI } from '@/utils/ajax'

const state = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  menu: {},
  campaign: {
    init: 0,
    initErr: [],
    menu: {},
    sideMenu: [],
    allIntermediary: false,
    promotionList: [],
    intermediaryList: [],
    appIDList: []
  },
  promotion: {
    init: 0,
    initErr: [],
    menu: {},
    sideMenu: [],
    appIDList: [],
    cardList: [],
    memberGroupList: [],
    stdPromo: false,
    usrGrpPromo: false,
    cardPromo: false,
    couponPromo: false,
    promoFactorTabMenu: 0,
    promoFactorDisplayFactReviewTab: false,
    promoFactorDisplayRateTab: false,
    promoFactorProduct: undefined,
    promoFactors: {
      fact1: null,
      fact2: null,
      fact3: null,
      fact4: null,
      fact5: null,
      fact6: null
    },
    factor1to3List: [],
    factor4to6List: [],
    promoFactorProductAppId: undefined
  }
}

const getters = {
}

const mutations = {
  [PROMOTION_MANAGEMENT_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [PROMOTION_MANAGEMENT_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [PROMOTION_MANAGEMENT_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [CAMPAIGN_INIT_LOADING](state) {
    state.campaign.init = 0
    state.campaign.initErr = []
    state.campaign.menu = {}
    state.campaign.sideMenu = []
    state.campaign.allIntermediary = false
    state.campaign.promotionList = []
    state.campaign.intermediaryList = []
    state.campaign.appIDList = []
  },
  [CAMPAIGN_INIT_SUCCESS](state, data) {
    state.campaign.init = 1
    state.campaign.initErr = []
    state.campaign.menu = data.menu
    state.campaign.allIntermediary = data.allIntermediary
    state.campaign.promotionList = data.promotionList
    state.campaign.intermediaryList = data.intermediaryList
    state.campaign.appIDList = data.appIDList
  },
  [CAMPAIGN_INIT_FAIL](state, error) {
    state.campaign.init = 2
    state.campaign.initErr = error
    state.campaign.menu = {}
    state.campaign.sideMenu = []
    state.campaign.allIntermediary = false
    state.campaign.promotionList = []
    state.campaign.intermediaryList = []
    state.campaign.appIDList = []
  },
  [CAMPAIGN_SIDEMENU](state, data) {
    state.campaign.sideMenu = data
  },
  [PROMOTION_INIT_LOADING](state) {
    state.promotion.init = 0
    state.promotion.initErr = []
    state.promotion.menu = {}
    state.promotion.sideMenu = []
    state.promotion.appIDList = []
    state.promotion.cardList = []
    state.promotion.memberGroupList = []
    state.promotion.stdPromo = false
    state.promotion.usrGrpPromo = false
    state.promotion.cardPromo = false
    state.promotion.couponPromo = false
  },
  [PROMOTION_INIT_SUCCESS](state, data) {
    state.promotion.init = 1
    state.promotion.initErr = []
    state.promotion.menu = data.menu

    state.promotion.appIDList = data.appIDList
    state.promotion.cardList = data.cardList
    state.promotion.memberGroupList = data.memberGroupList
    state.promotion.stdPromo = data.stdPromo
    state.promotion.usrGrpPromo = data.usrGrpPromo
    state.promotion.cardPromo = data.cardPromo
    state.promotion.couponPromo = data.couponPromo
  },
  [PROMOTION_INIT_FAIL](state, error) {
    state.promotion.init = 2
    state.promotion.initErr = error
    state.promotion.menu = {}
    state.promotion.sideMenu = []
    state.promotion.appIDList = []
    state.promotion.cardList = []
    state.promotion.memberGroupList = []
    state.promotion.stdPromo = false
    state.promotion.usrGrpPromo = false
    state.promotion.cardPromo = false
    state.promotion.couponPromo = false
  },
  [PROMOTION_SIDEMENU](state, data) {
    state.promotion.sideMenu = data
  },
  [PROMOTION_PROMOFACT_TABMENU](state, data) {
    state.promotion.promoFactorTabMenu = data.promoFactTab
    state.promotion.promoFactorDisplayFactReviewTab = data.displayFactReviewTab
    state.promotion.promoFactorDisplayRateTab = data.displayRateTab
    if (data.product) {
      state.promotion.promoFactorProduct = data.product
    }
  },
  [PROMOTION_PROMOFACT](state, data) {
    if (data) {
      state.promotion.promoFactors = data
    }
  },
  [PROMOTION_FACTORLIST](state, data) {
    if (data) {
      state.promotion.factor1to3List = data.factor1to3List
      state.promotion.factor4to6List = data.factor4to6List
      state.promotion.promoFactorProductAppId = data.appId
    }
  }
}

const actions = {
  async promotionManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.promotionManagement
    if (apiUrl) {
      commit(PROMOTION_MANAGEMENT_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        commit(PROMOTION_MANAGEMENT_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(PROMOTION_MANAGEMENT_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(PROMOTION_MANAGEMENT_INIT_FAIL, extractMessages(['Invalid API URL']))
    }
  },
  async campaignInit({ commit, state }, campaign) {
    commit(CAMPAIGN_INIT_LOADING)
    try {
      const apiURI = state.menu.campaignGet
      const expand = {
        campaign: campaign
      }
      const result = await http.get(expandURI(apiURI, expand))
      const menu = extractMenu(result.data._links)
      const commitResult = {
        allIntermediary: result.data.data.campaign.allIntermediary,
        promotionList: result.data.data.promotionList,
        intermediaryList: result.data.data.intermediaryList,
        appIDList: result.data.data.appIDList,
        menu: menu
      }
      commit(CAMPAIGN_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(CAMPAIGN_INIT_FAIL, extractMessages(error))
    }
  },
  async promotionInit({ commit, state }, promotion) {
    commit(PROMOTION_INIT_LOADING)
    try {
      const apiURI = state.menu.promotionGet
      const expand = {
        promotion: promotion
      }
      const result = await http.get(expandURI(apiURI, expand))
      const menu = extractMenu(result.data._links)
      const commitResult = {
        appIDList: result.data.data.appIDList,
        cardList: result.data.data.cardList,
        memberGroupList: result.data.data.memberGroupList,
        stdPromo: result.data.data.promotion.stdPromo,
        usrGrpPromo: result.data.data.promotion.usrGrpPromo,
        cardPromo: result.data.data.promotion.cardPromo,
        couponPromo: result.data.data.promotion.couponPromo,
        menu: menu
      }
      commit(PROMOTION_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(PROMOTION_INIT_FAIL, extractMessages(error))
    }
  }
}
export default {
  state,
  getters,
  mutations,
  actions
}
